export default __webpack_public_path__ + "static/media/ic-notes-add.a3833d02.svg";